import { useProfileConnectionsSchemas } from '@/core/api/profiles';
import type { ProfileConnectionSchema, ProfileConnectionSchemaDefinition } from '@/core/types/schemas';

export const useProfileKindPossibleConnections = (profileKind: string) => {
	const { data } = useProfileConnectionsSchemas();
	const profileConnectionsGraph = buildProfileConnectionsGraph(data);
	return profileConnectionsGraph[profileKind] ?? { connections: [], label: '' };
};

type GraphNode = {
	connections: string[];
	label: string;
};

export const buildProfileConnectionsGraph = (schemaData?: ProfileConnectionSchema | null) => {
	if (!schemaData) return {};

	const graph: Record<string, GraphNode> = {};

	Object.entries(schemaData.json_schema.$defs).forEach(([connectionType, defValue]) => {
		const def = defValue as ProfileConnectionSchemaDefinition;
		const profileAObjects =
			def.properties?.['@data']?.properties?.profile_a?.properties?._object?.['x-tf-accepted-objects'];
		const profileBObjects =
			def.properties?.['@data']?.properties?.profile_b?.properties?._object?.['x-tf-accepted-objects'];

		if (profileAObjects && profileBObjects) {
			const profileAKinds = profileAObjects.map((obj) => obj['@kind']);
			const profileBKinds = profileBObjects.map((obj) => obj['@kind']);

			const uiSchemaEntry = schemaData.ui_schema[connectionType];
			const profileALabel = uiSchemaEntry?.profile_a?.['ui:title'] ?? 'Connections';
			const profileBLabel = uiSchemaEntry?.profile_b?.['ui:title'] ?? 'Connections';

			profileAKinds.forEach((kindA) => {
				if (!graph[kindA]) {
					graph[kindA] = { connections: [], label: profileALabel };
				}

				profileBKinds.forEach((kindB) => {
					if (!graph[kindA].connections.includes(kindB)) {
						graph[kindA].connections.push(kindB);
					}
				});
			});

			profileBKinds.forEach((kindB) => {
				if (!graph[kindB]) {
					graph[kindB] = { connections: [], label: profileBLabel };
				}

				profileAKinds.forEach((kindA) => {
					if (!graph[kindB].connections.includes(kindA)) {
						graph[kindB].connections.push(kindA);
					}
				});
			});
		}
	});

	return graph;
};
